import BaseModel from "../../../core/components/input-widget/BaseModel";
import {store} from "@/plugins/vuex";

export default class MiscellaneousItem extends BaseModel {
  percentage = null;
  inventory_uuid = null;
  comment = null;
  amount = null;
  title = null;
  taxable = false;
  vat = null;
  title_dropdown_value = null;

  rules = {};

  attributeLabels = {};

  constructor(data = {}, forceUpdateDropdownData = false) {
    super();
    Object.assign(this, {...data, title_dropdown_value: null});
    let miscellaneousItemCharges = store.state.global.invoiceMiscellaneousItemCharges

    if (data.uuid || forceUpdateDropdownData) {
      let item = miscellaneousItemCharges.find(item => [item.value].includes(this.title));
      if (item) {
        this.title_dropdown_value = item.value;
      } else {
        this.title_dropdown_value = 'other';
      }
    }
  }

  toJSON() {
    let data = super.toJSON();
    if (data.title_dropdown_value !== 'other') {
      let item = store.state.global.invoiceMiscellaneousItemCharges.find(item => item.value === data.title_dropdown_value);
      if (item) {
        data.title = item.value;
      }
    }
    delete data.title_dropdown_value;
    return data;
  }
}
